module.exports = __webpack_public_path__ + "static/media/earth.11e7c60d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/lib/elements/earth.svg
// module id = 115
// module chunks = 0